module.exports = __webpack_public_path__ + "static/img_0245_dpp_optimized-a5db0eb9b6695f4809c934d8d55fbac7.jpg";